import isObjEmpty from "../../../../utils/helpers/isObjectEmpty";

export const cityCode = 1;
export const villageCode = 2;

export function isGeorgia(value) {
  return +value === 268;
}

export function isCity(value) {
  return +value === cityCode;
}

export function isVillage(value) {
  return +value === villageCode;
}

export function isGeoCode(code) {
  return +code === 268;
}

export const cityOrVillage = [
  {
    referenceId: cityCode,
    referenceNameEn: "City",
    referenceNameGe: "ქალაქი",
  },
  {
    referenceId: villageCode,
    referenceNameEn: "Village",
    referenceNameGe: "სოფელი",
  },
];

export const fieldNames = {
  BIRTH_COUNTRY: "birthCountry",
  BIRTH_CITY: "birthCity",
  CITY: "city",
  COUNTRY_CODE: "countryCode",
  COUNTRY: "country",
  CITY_VILLAGE: "cityVillage",
  APARTMENT_NUMBER: "apartmentNumber",
  HOME_NUMBER: "homeNumber",
  STREET: "street",
  DUAL_CITIZENSHIP: "dualCitizenship",
  IS_ACTUAL_ADDRESS: "isActualAddress",
  IS_CITY: "isCity",
  VILLAGE: "village",
  LEGAL_ADDRESS: "legal_address",
  ACTUAL_ADDRESS: "actual_address",
  SEX: "sex",
  DUAL_CITIZENSHIP_COUNTRY: "dual_citizenshipt_country",
  FIRSTNAME: "FirstName",
  LASTNAME: "lastname",
  GENDER: "gender",
  CITIZENSHIP: "citizenship",
  ISDUALCITIZEN: "isdualcitizen",
  SECONDARYCITIZENSHIP: "secondarycitizenship",
  ISRESIDENT: "isresident",
  IDORDOCUMENTNUMBER: "idordocumentnumber",
  COUNTRYOFBIRTH: "countryofbirth",
  CITYOFBIRTH: "cityofbirth",
  DATEOFBIRTH: "dateofbirth",
  CITY_ID: "city",
  CARD_INFO: "cardInfo",
  DELIVERY_METHOD: "deliveryMethod",
  DELIVERY_ADDRESS: "deliveryAddress",
  MAIN_CURRENCY: "mainCurrency",
  BRANCH_ID: "branchId",
};

// function returns true if we have address.actualAddress.country and address.Actualaddress.homeNUmber
export function doWeHaveActualAddress(address) {
  const { [fieldNames.ACTUAL_ADDRESS]: actualAddress } = address;
  if (!actualAddress) return false;
  const { [fieldNames.COUNTRY]: country } = actualAddress;

  return !!country;
}

// gets valuee from obj with string key (obj['value.value'])
export function getNestedValue(obj, string) {
  if (!string) {
    return null;
  }
  const values = string.split(".");
  let result = { ...obj };

  for (let i = 0; i < values.length; i++) {
    if (!result || isObjEmpty(result)) return "";
    result = result[values[i]] || "";
  }
  return result;
}

export function isContentGeorgian(lang) {
  return lang === "ka";
}

export function withNameSpace(namespace, fieldName) {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
}

export function withTwoNameSpaces(namespace, secondName, fieldName) {
  return namespace ? `${namespace}.${secondName}.${fieldName}` : fieldName;
}

export function moveGeorgiaUp(data) {
  return data.sort(({ referenceId }) => {
    if (isGeorgia(referenceId)) {
      return -1;
    }
    return 1;
  });
}

export const EMPLOYMENT_STATUSES = {
  employed: 1,
  selfEmployed: 2,
  businessOwner: 3,
  soleProprietor: 5,
  student: 6,
  retired: 7,
  indEnterpr: 4,
};

export const PERSONAL_INFO_STEPS = {
  personDetails: 1,
  pepAndKyc: 2,
};

export const PI_TYPES = {
  privateIndividual: 2, // არამეწარმე
  entNaturalPerson: 11, //ინდივიდუალური მეწერარმე
  privateEnt: 10, // მეწარმე ფიზიკური პირი
};

function selectValuesFromResponse(
  data,
  locale,
  valuePropertyName = "referenceId"
) {
  return data?.map((item) => {
    const label =
      locale === "en" ? item?.referenceNameEn : item?.referenceNameGe;

    return { value: item?.[valuePropertyName], label };
  });
}

export { selectValuesFromResponse };

export const ACCOUNT_PURPOSES_VALUE = {
  accounts: 1,
  deposit: 3,
  loan: 4,
  nonCashTransactions: 5,
  intTransfers: 6,
  guarantee: 7,
  cashTransactions: 8,
  remittances: 9,
};

export const ACCOUNT_PURPOSES_DEFAULT_VALUES = [
  ACCOUNT_PURPOSES_VALUE.accounts,
  ACCOUNT_PURPOSES_VALUE.distanceServices,
];

export const YES_NO_VAL = {
  yes: 1,
  no: 2,
};

export const FATCA_TAX_CLASS_OTHER = 7;

export const KYC_OTHER = {
  assetVal: 3,
  moneySourceVal: 12,
  propSourceVal: 3,
};

export const KYC_ASSET_VALUES = {
  realEstate: 1,
  shares: 2,
  otherImportantAssets: 3,
  noAssets: 8,
};

export const PROPERTY_ASSET_VALUES = [
  KYC_ASSET_VALUES.realEstate,
  KYC_ASSET_VALUES.shares,
  KYC_ASSET_VALUES.otherImportantAssets,
];

export const PEP_CATEGORIES = {
  exposedPerson: 1,
  familyMember: 2,
  businessRel: 3,
  additional: 4,
};

export const YES_NO_QUESTIONS = [
  "dualCitizenShip",
  "isGreenCardHolder",
  "isPep",
];

export const SUBFORM_PREFIXES = ["actualAddress", "pep", "kyc", "fatca"];

export const TEXT_INPUT_PATTERN = /[\u10A0-\u10FF\u2D00-\u2D2F\u1C90-\u1CBF]/g;

export const getFulName = (lang, person) => {
  let name,
    lastName = "";

  if (isContentGeorgian(lang)) {
    name = person?.localFirstName;
    lastName = person?.localLastName;
  } else {
    name = person?.firstName;
    lastName = person?.lastName;
  }

  return { name, lastName };
};

export const AML_COUNTRY_RISK = 100;
